import { User, UserControllerApi } from "../services";
import { getConfigObject, useMutationWithLoading } from "../utils/utils";

/**
 * @author rajkumar rathod
 */
export const useUpdateUser = () =>
  useMutationWithLoading(
    async (params: { user: User } & { xTENANTID?: string }) =>
      new UserControllerApi(getConfigObject()).updateUser(
        params.user,
        params.xTENANTID
      )
  );
